export const MODULES = {
  MODULO_CABECERAS_SOLUCIONES_DIGITALES: 'MODULO_CABECERAS_SOLUCIONES_DIGITALES',
  MODULO_VIDEO_SOLUCIONES_DIGITALES: 'MODULO_VIDEO_SOLUCIONES_DIGITALES',
  MODULO_INTRODUCCION_SOLUCIONES_DIGITALES: 'MODULO_INTRODUCCION_SOLUCIONES_DIGITALES',
  MODULO_VENTAJAS_SOLUCIONES_DIGITALES: 'MODULO_VENTAJAS_SOLUCIONES_DIGITALES',
  MODULO_FRASE_DESTACADA: 'MODULO_FRASE_DESTACADA_SOLUCIONES_DIGITALES',
  MODULO_BANNER_CTA: 'MODULO_BANNER_CTA',
  MODULO_BANNER_CTA_WHITE: 'MODULO_BANNER_CTA_WHITE',
  MODULO_CLAVES_LISTADO: 'MODULO_CLAVES_LISTADO',
  MODULO_H2_TITLE: 'MODULO_H2_TITLE',
  MODULO_RESULTADOS_PORCENTAJES: 'MODULO_RESULTADOS_PORCENTAJES',
  MODULO_FAQS_PREGUNTAS_FRECUENTES: 'FAQS_PREGUNTAS_FRECUENTES',
  MODULO_IMAGE_CIRCLE: 'MODULO_SOLUCIONES_SOLUCIONES_DIGITALES',
  MODULO_NECESIDADES: 'MODULO_NECESIDADES',
  MODULO_PRINCIPAL_CATEGORIAS: 'MODULO_PRINCIPAL_CATEGORIAS',
  MODULO_CONTRATOS: 'MODULO_DESCARGA_TITLE_SUBTITLE_PRODUCTOS_CONTRATOS_FONDOS_EUROPEOS',
  MODULO_TITLE: 'MODULO_TITLE_SUBTITLE',
  MODULO_SELECTOR_EMPLEADOS: 'MODULO_SELECTOR_EMPLEADOS',
  MODULO_SELECTOR_EMPLEADOS_CONTRATOS: 'MODULO_SELECTOR_EMPLEADOS_CONTRATOS',
  MODULO_CIRCLE_LIST: 'MODULO_CIRCLE_LIST',
  MODULO_BANNER_CTA_OFERTAS: 'MODULO_BANNER_CTA_OFERTAS',
}
